import React from "react"
import FaIcon from "components/fa_icon"

export default ({name}) => {
  const className = (() => {
    switch (name.toLowerCase()) {
      case "videos":
      case "video":
        return "fa-youtube-play"
      case "quizzes":
      case "quiz":
      case "training":
        return "fa-graduation-cap"
      case "articles":
      case "article":
        return "fa-file-text"
      case "learnable":
        return "fa-globe"
      default:
        return null
    }
  })()
  if (!className) return null

  return <FaIcon name={className} />
}
